import { faUserShield } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import LegalPageLayout from "../Components/LegalPageLayout";

function PrivacyCB() {
  return (
    <LegalPageLayout
      titleId="privacy-cb-title"
      icon={faUserShield}
      title="Privacy Policy (CashBook)"
      description={
        <p>
          Your privacy is our priority. This page explains how CashBook handles
          information.
        </p>
      }
    >
      <p className="effective-date">Effective Date: June 18, 2026</p>
      <p>
        CashBook is a mobile application developed and operated by MileSoft.
        MileSoft is the data controller for personal information processed
        through CashBook. For privacy requests, data protection officer (DPO)
        requests, and controller contact purposes, email us at{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>.
      </p>

      <h5>Information We Collect</h5>
      <p>CashBook may collect or process the following information:</p>
      <ul>
        <li>Name and email address for account management</li>
        <li>Login credentials and user ID for authentication</li>
        <li>Financial records that you enter into the app</li>
        <li>App activity needed to provide CashBook features</li>
        <li>
          Device ID, device type, operating system, app version, crash logs,
          diagnostics, and error logs for security and reliability
        </li>
      </ul>

      <h5>How We Use Information and Legal Basis</h5>
      <p>
        We process information to provide CashBook, authenticate users, save and
        display account and financial records, provide support, protect against
        misuse, comply with legal obligations, and improve app reliability. Our
        legal basis for processing may include performance of a contract or
        requested service, consent, legitimate interests in operating and
        securing the app, legal obligations, and processing requested by you.
      </p>

      <h5>Data Sharing, Sales, and Targeted Advertising</h5>
      <p>
        MileSoft does not sell personal information. CashBook does not share
        personal information with unrelated third parties for their own
        marketing. We may share limited information with service providers
        needed to operate the app, when required by law, to protect users and
        systems, or during a business transfer.
      </p>
      <p>
        You may opt out of any sale, sharing, or targeted advertising use of
        personal information by emailing{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>. We
        will honor applicable opt-out rights even though we do not sell personal
        information.
      </p>

      <h5>Security and Encryption</h5>
      <p>
        We use reasonable technical and organizational safeguards, including
        HTTPS and encryption in transit where data is sent to our services or
        service providers, authentication controls, and cloud security
        protections. No system can guarantee absolute security.
      </p>

      <h5>Data Retention</h5>
      <p>
        We retain information while your CashBook account remains active or as
        needed to provide the app. After account deletion, we delete or
        anonymize personal information unless limited retention is required or
        permitted for legal compliance, security, fraud prevention, dispute
        resolution, backups, or accounting records.
      </p>

      <h5>Account and Data Deletion</h5>
      <p>
        You may request deletion of your CashBook account and associated data
        through{" "}
        <a href="https://milesoft.co/delete-account-cb">
          Delete Account Request
        </a>{" "}
        or by emailing{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>.
        Please use the email address linked to your CashBook account so we can
        identify your account.
      </p>

      <h5>Your Privacy Rights</h5>
      <h6>Right to Know About Data Sharing</h6>
      <p>
        You have the right to ask whether MileSoft shares your personal
        information and, where applicable, the categories of personal
        information shared, the purposes for sharing, and the categories of
        recipients. You may make this request using the contact details below.
      </p>
      <p>
        Depending on where you live, including under the GDPR, CCPA/CPRA, VCDPA,
        LGPD, and other applicable privacy laws, you may have the right to
        request access to personal information we collect, request correction or
        rectification of inaccurate information, request deletion, request a
        portable copy, object to or restrict certain processing, withdraw
        consent where processing is based on consent, and know whether personal
        information is sold or shared.
      </p>
      <p>
        California residents may exercise CCPA/CPRA rights to know, access,
        correct, delete, and opt out of sale or sharing. Virginia residents may
        exercise VCDPA rights to access, correct, delete, obtain a copy, and opt
        out of targeted advertising, sale, or certain profiling. Users in Brazil
        may exercise LGPD rights, including confirmation, access, correction,
        anonymization, deletion, portability, information about sharing, and
        consent withdrawal. Users in the EEA or UK may exercise GDPR rights,
        including access, rectification, erasure, restriction, objection,
        portability, and the right to lodge a complaint with a supervisory
        authority.
      </p>
      <p>
        To make a privacy rights request, contact{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>.
      </p>

      <h5>Changes to This Privacy Policy</h5>
      <p>
        MileSoft may update this Privacy Policy from time to time. When we
        update it, we will revise the effective date and may notify users
        through the app, email, or another reasonable method.
      </p>

      <h5>Contact Us</h5>
      <p>
        <strong>Company and App Provider:</strong> MileSoft
        <br />
        <strong>App:</strong> CashBook
        <br />
        <strong>Controller and DPO Contact:</strong>{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>
        <br />
        <strong>Location:</strong> Malawi
      </p>
    </LegalPageLayout>
  );
}

export default PrivacyCB;
